/**
 * Inteligência's own copy: the three screens' headings, the detection settings dialog, the dimension list and
 * its value tree, and the proposals queue. "organização", never "tenant" -- the reader is the
 * tenant admin, not the person who built this.
 */

import { defineCatalogue } from '../../../i18n';

export const ontologyCatalogue = defineCatalogue(
  {
    'nav.group': 'Inteligência',
    'nav.posts': 'Posts',
    'nav.comments': 'Comentários',
    'nav.profiles': 'Perfis',

    'page.posts.title': 'Posts',
    'page.comments.title': 'Comentários',
    'page.profiles.title': 'Perfis',

    'flags.heading': 'Detecção automática',
    'flags.ner_posts': 'Detectar entidades nomeadas (NER) nas publicações',
    'flags.ner_comments': 'Detectar entidades nomeadas (NER) nos comentários',
    'flags.profile_in_comments': 'Usar o perfil do comentarista na análise',
    'flags.profile_recent_posts':
      'Incluir publicações recentes do perfil (uma chamada paga a mais)',
    'flags.autoAccept.heading': 'Aceitar automaticamente quando',
    'flags.autoAccept.confidence.label': 'Confiança mínima',
    'flags.autoAccept.confidence.value': '{value}%',
    'flags.autoAccept.occurrences.label': 'Ocorrências mínimas',
    'flags.autoAccept.occurrences.invalid': 'Use um número inteiro a partir de 1.',
    'flags.autoAccept.shared': 'Vale para Posts e Comentários.',
    'flags.save': 'Salvar',
    'settings.open': 'Configurações',
    'flags.saved': 'Configurações salvas.',

    'dimensions.heading': 'Dimensões',
    'dimensions.new': 'Nova dimensão',
    'dimensions.new.title': 'Nova dimensão',
    'dimensions.new.name.label': 'Nome',
    'dimensions.new.name.required': 'Escreva um nome para a dimensão.',
    'dimensions.rename.title': 'Renomear dimensão',
    'dimensions.extract.label': 'Detectar',
    'dimensions.extension.suggest': 'Sugerir novos valores',
    'dimensions.extension.auto': 'Aprovar automaticamente',
    'dimensions.extension.profileHint': 'Novos valores de perfil sempre aguardam um administrador.',
    'dimensions.sensitive.badge': 'Sensível',
    'dimensions.actions.rename': 'Renomear',
    'dimensions.actions.delete': 'Excluir dimensão',
    'dimensions.delete.title': 'Excluir a dimensão "{name}"?',
    'dimensions.delete.description': 'As menções desta dimensão são removidas.',
    'dimensions.delete.confirm': 'Excluir',

    'values.add': 'Adicionar valor',
    'values.addChild': 'Adicionar filho',
    'values.new.title': 'Novo valor',
    'values.new.submit': 'Adicionar',
    'values.new.name.label': 'Nome',
    'values.new.name.required': 'Escreva um nome para o valor.',
    'values.rename.title': 'Renomear valor',
    'values.aliases.title': 'Apelidos de "{name}"',
    'values.aliases.label': 'Apelidos',
    'values.aliases.add.placeholder': 'Novo apelido',
    'values.aliases.add': 'Adicionar',
    'values.aliases.remove': 'Remover apelido {alias}',
    'values.move.title': 'Mover "{name}" para…',
    'values.move.top': 'Nível superior',
    'values.merge.title': 'Mesclar "{name}" em…',
    'values.merge.description': 'Os apelidos e as menções passam para {target}.',
    'values.merge.confirm': 'Mesclar',
    'values.delete.title': 'Excluir "{name}"?',
    'values.delete.description': 'As menções vão para Não identificado.',
    'values.delete.confirm': 'Excluir',
    'values.actions.label': 'Ações de {name}',
    'values.actions.rename': 'Renomear',
    'values.actions.editAliases': 'Editar apelidos',
    'values.actions.addChild': 'Adicionar filho',
    'values.actions.move': 'Mover para…',
    'values.actions.merge': 'Mesclar em…',
    'values.actions.delete': 'Excluir',
    'values.unidentified': 'Não identificado',
    'values.mentions.other': '{n} menções',
    'values.mentions.one': '{n} menção',
    'values.readings.other': '{n} leituras',
    'values.readings.one': '{n} leitura',
    'values.readings.hint':
      'Cada publicação conta a pessoa uma vez; quem comentou em várias publicações aparece em cada uma.',
    'values.picker.searchPlaceholder': 'Buscar valor',
    'values.picker.empty': 'Nenhum valor encontrado',

    'proposals.heading': 'Propostas',
    'proposals.occurrences.other': '{n} ocorrências',
    'proposals.occurrences.one': '{n} ocorrência',
    'proposals.confidence': 'Confiança {value}',
    'proposals.approve': 'Aprovar',
    'proposals.approved': 'Adicionado a {dimension}',
    'proposals.approve.failed': 'Não foi possível aprovar "{name}"',
    'nav.proposals.pending.other': '{n} propostas pendentes',
    'nav.proposals.pending.one': '{n} proposta pendente',
    'proposals.mergeInto': 'Mesclar em…',
    'proposals.merge.title': 'Mesclar "{name}" em…',
    'proposals.reject': 'Rejeitar',

    'empty.title': 'A ontologia desta organização ainda não foi criada',
    'empty.seed': 'Criar a partir do modelo padrão',
    'empty.awaitingApproval': 'O modelo padrão está aguardando aprovação de um administrador.',
    'empty.seeded.other': '{n} itens adicionados.',
    'empty.seeded.one': '{n} item adicionado.',

    'error.retry': 'Tentar de novo',
  },
  {
    'nav.group': 'Intelligence',
    'nav.posts': 'Posts',
    'nav.comments': 'Comments',
    'nav.profiles': 'Profiles',

    'page.posts.title': 'Posts',
    'page.comments.title': 'Comments',
    'page.profiles.title': 'Profiles',

    'flags.heading': 'Automatic detection',
    'flags.ner_posts': 'Detect named entities (NER) in posts',
    'flags.ner_comments': 'Detect named entities (NER) in comments',
    'flags.profile_in_comments': "Use the commenter's profile in the analysis",
    'flags.profile_recent_posts': "Include the profile's recent posts (one extra paid call)",
    'flags.autoAccept.heading': 'Accept automatically when',
    'flags.autoAccept.confidence.label': 'Minimum confidence',
    'flags.autoAccept.confidence.value': '{value}%',
    'flags.autoAccept.occurrences.label': 'Minimum occurrences',
    'flags.autoAccept.occurrences.invalid': 'Use a whole number of 1 or more.',
    'flags.autoAccept.shared': 'Applies to Posts and Comments.',
    'flags.save': 'Save',
    'settings.open': 'Settings',
    'flags.saved': 'Settings saved.',

    'dimensions.heading': 'Dimensions',
    'dimensions.new': 'New dimension',
    'dimensions.new.title': 'New dimension',
    'dimensions.new.name.label': 'Name',
    'dimensions.new.name.required': 'Write a name for the dimension.',
    'dimensions.rename.title': 'Rename dimension',
    'dimensions.extract.label': 'Detect',
    'dimensions.extension.suggest': 'Suggest new values',
    'dimensions.extension.auto': 'Approve automatically',
    'dimensions.extension.profileHint': 'New profile values always wait for an administrator.',
    'dimensions.sensitive.badge': 'Sensitive',
    'dimensions.actions.rename': 'Rename',
    'dimensions.actions.delete': 'Delete dimension',
    'dimensions.delete.title': 'Delete "{name}"?',
    'dimensions.delete.description': 'This dimension’s mentions are removed.',
    'dimensions.delete.confirm': 'Delete',

    'values.add': 'Add value',
    'values.addChild': 'Add child',
    'values.new.title': 'New value',
    'values.new.submit': 'Add',
    'values.new.name.label': 'Name',
    'values.new.name.required': 'Write a name for the value.',
    'values.rename.title': 'Rename value',
    'values.aliases.title': '"{name}" aliases',
    'values.aliases.label': 'Aliases',
    'values.aliases.add.placeholder': 'New alias',
    'values.aliases.add': 'Add',
    'values.aliases.remove': 'Remove alias {alias}',
    'values.move.title': 'Move "{name}" to…',
    'values.move.top': 'Top level',
    'values.merge.title': 'Merge "{name}" into…',
    'values.merge.description': 'Its aliases and mentions move to {target}.',
    'values.merge.confirm': 'Merge',
    'values.delete.title': 'Delete "{name}"?',
    'values.delete.description': 'Its mentions move to Unidentified.',
    'values.delete.confirm': 'Delete',
    'values.actions.label': '{name} actions',
    'values.actions.rename': 'Rename',
    'values.actions.editAliases': 'Edit aliases',
    'values.actions.addChild': 'Add child',
    'values.actions.move': 'Move to…',
    'values.actions.merge': 'Merge into…',
    'values.actions.delete': 'Delete',
    'values.unidentified': 'Unidentified',
    'values.mentions.other': '{n} mentions',
    'values.mentions.one': '{n} mention',
    'values.readings.other': '{n} readings',
    'values.readings.one': '{n} reading',
    'values.readings.hint':
      'Each post counts a person once; someone who commented on several posts appears in each.',
    'values.picker.searchPlaceholder': 'Search value',
    'values.picker.empty': 'No value found',

    'proposals.heading': 'Proposals',
    'proposals.occurrences.other': '{n} occurrences',
    'proposals.occurrences.one': '{n} occurrence',
    'proposals.confidence': 'Confidence {value}',
    'proposals.approve': 'Approve',
    'proposals.approved': 'Added to {dimension}',
    'proposals.approve.failed': 'Could not approve "{name}"',
    'nav.proposals.pending.other': '{n} pending proposals',
    'nav.proposals.pending.one': '{n} pending proposal',
    'proposals.mergeInto': 'Merge into…',
    'proposals.merge.title': 'Merge "{name}" into…',
    'proposals.reject': 'Reject',

    'empty.title': "This organisation's ontology has not been created yet",
    'empty.seed': 'Create from the default model',
    'empty.awaitingApproval': "The default model is awaiting an administrator's approval.",
    'empty.seeded.other': '{n} items added.',
    'empty.seeded.one': '{n} item added.',

    'error.retry': 'Try again',
  },
);

export const om = ontologyCatalogue.t;
export const omPlural = ontologyCatalogue.plural;
